import { authenticate } from '@kiper/fns';
import { getLast } from './changelog.manager';

export const getLastChangeLog = authenticate(({ args, context }) =>
  getLast({ ...args, ...context }),
);